import BatchFilesCreateModal from "./BatchFilesCreateModal"

export default BatchFilesCreateModal
